import { config } from '@/config';
import { RECAPTCHA_V3_URL } from '@/config/externalScriptsUrl';

const isOnboarding = window.location.pathname.includes('onboarding');

export const loadReCaptcha = (isOnboardingFlow = isOnboarding) => {
  if (isOnboardingFlow) return;

  const scriptExists = id => !!document.getElementById(id);
  const createScript = (id, src) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    document.body.appendChild(script);
  };

  const defaultRecaptcha = {
    id: 'recaptcha-script',
    src: RECAPTCHA_V3_URL(config.RECAPTCHA_SITE_KEY),
  };
  const gatorResolveRecaptcha = {
    id: 'recaptcha-script-gator-resolve',
    src: RECAPTCHA_V3_URL(config.RECAPTCHA_SITE_KEY_FOXTROT),
  };

  const hasDefaultScript = scriptExists(defaultRecaptcha.id);
  const hasGatorResolveScript = scriptExists(gatorResolveRecaptcha.id);

  if (!hasDefaultScript && !hasGatorResolveScript) {
    createScript(defaultRecaptcha.id, defaultRecaptcha.src);
  }

  if (!hasGatorResolveScript) {
    createScript(gatorResolveRecaptcha.id, gatorResolveRecaptcha.src);

    if (hasDefaultScript) {
      document.getElementById(defaultRecaptcha.id).remove();
    }
  }
};

export const generateRecaptchaToken = async (sitekey, action) => {
  let tokenReceived = '';
  await window.grecaptcha.execute(sitekey, { action })
    .then((token) => {
      tokenReceived = token;
    });
  return tokenReceived;
};

export const loadReCaptchaPaaS = () => {
  if (isOnboarding) return;
  const hasRecaptchaScript = document.getElementById('recaptcha-script-paas');
  const hasNewRecaptchaScript = document.getElementById('new-recaptcha-script-paas');

  if (!hasRecaptchaScript && !hasNewRecaptchaScript) {
    const script = document.createElement('script');
    script.id = 'recaptcha-script-paas';
    script.src = RECAPTCHA_V3_URL(config.RECAPTCHA_PAAS);
    document.body.appendChild(script);
  }
  if (!hasNewRecaptchaScript) {
    const script = document.createElement('script');
    script.id = 'new-recaptcha-script-paas';
    script.src = RECAPTCHA_V3_URL(config.NEW_RECAPTCHA_PAAS);
    document.body.appendChild(script);

    if (hasRecaptchaScript) {
      const element = document.getElementById('recaptcha-script-paas');
      element.remove();
    }
  }
};
